// @ts-nocheck
import { createBrowserHistory, History } from '/data/app/jenkins/data/workspace/FESingleCommon/node_modules/.pnpm/@umijs+runtime@3.5.40_react@17.0.2/node_modules/@umijs/runtime';

let options = {
  "basename": "/epaas"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
